import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { Button } from '../../genericComponents';
import MembershipComponent from './MembershipComponent'

import BlueHero from '../../../assets/images/sprites/blueHero.jpg';


export default function SelectSubscriptionComponent({
  selectMembershipClick,
  membershipArray,
  rejectClick,
  needRetryPayment,
  user
}) {

  const [membershipComponents, setMembershipComponents] = useState(null)
  function selectHandler({ target }) {
    selectMembershipClick(target.value)
  }


  useEffect(() => {
    if (membershipArray) {

      let components = membershipArray.map((membership) => {
        const { name, price, type, active, payment_interval } = membership
        let selectedStyle = (user.membership.type === type) ? { border: '3px solid', fontWeight: "bold" } : {};
        return (
          <MembershipContainer style={selectedStyle} key={type}>
            <MembershipComponent membership={{ name, price, payment_interval }}
              features={membership.membership_features}
            />
            {active ?
              <SelectButton onClick={(user.membership.type === type) ? null : selectHandler} value={type}>
                {(user.membership.type === type) ? 'Current Subscription' : `Choose ${name}`}
              </SelectButton>
              :
              <SelectButton>Coming soon</SelectButton>
            }
          </MembershipContainer>
        )

      })
      setMembershipComponents(components)
    }
  }, [membershipArray])
  const clickHandler = ({ target }) => {
    rejectClick()
  }

  if (!membershipComponents)
    return null;
  else return (
    <Container>
      <HeadContainer>
        <Title>
          Join GABA's Exclusive community
        </Title>
        <Rectangle />
        <Message>
          Oh no! Your trial period has expired.
          We want you to continue being a valued member of the GABA community.
          Please select a membership package below to keep growing with us:
        </Message>
      </HeadContainer>
      {needRetryPayment && (
        <RetryContainer>
          <RetrySubContainer>
            You have a pending payment, you can create a new subscription or pay the existing subscription in <Link href={"/membership"}>Membership Page</Link>
          </RetrySubContainer>
        </RetryContainer>
      )}
      <ContentContainer>
        {membershipComponents}
        <CancelMessage onClick={clickHandler} >Nah, I don't want to join GABA right now</CancelMessage>
      </ContentContainer>

    </Container >
  );
};


const RetryContainer = styled.div`
  margin-top: 40px;
  font-size: 1.6em;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.2em;
`;
const RetrySubContainer = styled.div`
  max-width: 800px;
`;
const Link = styled.a`
  text-decoration: underline;
`;
const Container = styled.div`
  color:  ${(props) => props.theme.color.darkBlue};
  text-align:center;
`;
const SelectButton = styled(Button)`
  margin:0 auto;
  display:block;
  min-width: 200px;
  height: 48px;
  padding:0px;
  background: ${props => props.theme.color.gabaYellow};
  border-radius: 5px;
  bottom:1%;
`;
const HeadContainer = styled.div`
  background-image: url(${BlueHero});
  padding: 20px 0;
`;

const ContentContainer = styled.div`
  text-align:left;
  display: flex;
  justify-content:space-between;
  flex-wrap: wrap;
  width: 100%;
  padding-left:50px;
  padding-right:50px;
  .modal-video-body {
    margin-top: -300px;
  }
  margin-bottom: 30px;
`;

const Title = styled.div`
  font-size: 24px;
  font-family: Gotham-Medium;
  font-weight: 500;
  letter-spacing: -0.3px;
  line-height: 38px;
  color:  ${(props) => props.theme.color.white};
`;

const Message = styled.div`
  max-width: 620px;
  margin:0 auto;
  font-size: 18px;
  font-family: Gotham-Medium;
  font-weight: 500;
  color:  ${(props) => props.theme.color.white};
`;

const Rectangle = styled.div`
  margin:0 auto;
  width: 620px;
  height: 2px;
  background:  ${props => props.theme.color.white};
`;

const MembershipContainer = styled.div`
  margin: 20px auto;
  font-size: 16px;
  min-height: 600px;
  padding: 20px;
  width: 25%;
  min-width: 250px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  border-radius:10px;
  background:${(props) => props.theme.color.softYellow};
`;
const CancelMessage = styled(Button)`
  width: 100%;
  flex-basis: 100%;
  min-height: 48px;
  border: 1px solid ${props => props.theme.color.darkBlue};
  border-radius: 6px;
  color: ${props => props.theme.color.darkBlue};
  background-color: ${(props) => props.theme.color.softPurple};
`;